export default function certificateSlider() {

    const promotion = document.querySelector('.js-Promotion');

    if (!promotion) {
        return false;
    }

    function initPromotion() {

        if (promotion.childElementCount == 1) {
            return false;
        }

        if (window.innerWidth > 1200) {
            return false;
        }

        if (promotion.childElementCount <= 2 && window.innerWidth <= 1200 && window.innerWidth > 540) {
            return false;
        }

        $('.js-Promotion').not('.slick-initialized').slick({
            infinite: false,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            dotsClass: 'promotion_dots',
        });
    }

    function adaptive(script) {
        script();

        ['resize', 'orientationChange'].forEach( function(item) {
            window.addEventListener(item, script);
        });
    }

    adaptive(initPromotion);

}